import { render, staticRenderFns } from "./tickling.vue?vue&type=template&id=bb186100&scoped=true"
import script from "./tickling.vue?vue&type=script&lang=js"
export * from "./tickling.vue?vue&type=script&lang=js"
import style0 from "./tickling.vue?vue&type=style&index=0&id=bb186100&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb186100",
  null
  
)

export default component.exports